import { render, staticRenderFns } from "./DataFilters.vue?vue&type=template&id=ff15bb96&scoped=true"
import script from "./DataFilters.vue?vue&type=script&lang=ts"
export * from "./DataFilters.vue?vue&type=script&lang=ts"
import style0 from "./DataFilters.vue?vue&type=style&index=0&id=ff15bb96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff15bb96",
  null
  
)

export default component.exports